var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"downloadBtn",on:{"click":_vm.EventBusShowQRcode}},[_c('span',{staticClass:"icon",class:_vm.platform}),_vm._v(" "+_vm._s(_vm.$t(("download." + _vm.platform)))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }